import { IFormContext } from 'rewire-ui';
import DataMutations from '../graphql/Mutations';
import DataQueries from '../graphql/Queries';
import timeOffBalancesDialogModel from './TimeOffBalancesDialogModel';
import employeeViewTypeModel from '../settings/EmployeeViewTypeModel';
import mainPageModel from '../main-navigation/MainPageModel';
import DocumentDialogModel, { DocumentSchema } from './DocumentDialogModel';
import { createInviteForMobile } from '../settings/CustomFormFields';

const EmployeeSchema = `
  ${DocumentSchema}
  email
  isPayable
  phone {
    home
    mobile
    work
    fax
    workFax
  }
`;

// function inviteForMobile(form: IFormContext) {
//   const inviteForMobile = authService.evalSecurityToken('create_delete_users');
//   if (!inviteForMobile) return {};
//   return {
//     hasMobileAccess: createButton(
//       form,
//       'Invite To Mobile',
//       () => {
//         if (!mainPageModel.canAddUsers) return;
//         inviteDialogModel.load();
//         inviteDialogModel.form.setFieldValue('email', this.form.field.email.value);
//         inviteDialogModel.form.setFieldValue('role', { id: 'employee', code: 'employee', name: 'Employee' });
//         const employee = this.form.toObjectValues();
//         employee.id = this.id;
//         inviteDialogModel.form.setFieldValue('employee', employee);
//         // authService.inviteEmployeeToMobileAccess(obj.id).catch((err) => {
//         //   console.error('failed to invite employee to mobile access', err);
//         // });
//       },
//       'span1',
//       () => this.isNew || !this.form.field.email.value,
//     ),
//   };
// }

export class EmployeeDialogModel extends DocumentDialogModel {
  constructor() {
    super(
      'Employee',
      (ids: string[]) => DataQueries.getEmployeesByIds(EmployeeSchema, ids),
      DataMutations.insertEmployees,
      DataMutations.updateEmployees,
      DataMutations.deleteEmployees,
      'employees',
      () => mainPageModel.canAddEmployees,
      () => mainPageModel.canEditEmployees,
      () => mainPageModel.canDeleteEmployees,
    );
  }

  protected otherFields(form: IFormContext) {
    return {
      email: form.email({ icon: 'email' }).label('Email').placeholder('enter email'),
      hasMobileAccess: createInviteForMobile(this, form),
      isPayable: form.boolean().label('Is Paid').placeholder('check if employee is payable'),
      phone: form.phone({ icon: 'phone' }).accessor(['phone', 'home']).label('Home').placeholder('enter home phone number'),
      mobile: form.phone({ icon: 'phone' }).accessor(['phone', 'mobile']).label('Mobile').placeholder('enter mobile phone number'),
      work: form.phone({ icon: 'phone' }).accessor(['phone', 'work']).label('Work').placeholder('enter work phone number'),
      fax: form.phone({ icon: 'phone' }).accessor(['phone', 'fax']).label('Fax').placeholder('enter fax number'),
      workFax: form.phone({ icon: 'phone' }).accessor(['phone', 'workFax']).label('Work Fax').placeholder('enter work fax number'),
    };
  }

  _reset() {
    super._reset({ isPayable: true });
  }

  async load(id?: string, isModal: boolean = true) {
    this.isLoading = true;
    this.id = id;
    this.isModal = isModal;
    await this.loadView();
    this.state.title = this.getTitle();
    this.open();
    this.isLoading = false;
  }

  async loadView() {
    this.state.enable = false;
    if (this.isNew || employeeViewTypeModel.isView('details') || employeeViewTypeModel.isView('balances')) {
      // load employee details
      if (!this.isNew) {
        const results = await this._load([this.id!]);
        if (!results || results.length !== 1 || !results[0]) {
          this._reset();
        } else {
          this.form.value = this.mapToForm(results[0]);
        }
      } else {
        this._reset();
      }
      if (employeeViewTypeModel.isView('balances')) {
        // load time off balances
        await timeOffBalancesDialogModel.loadTimeOffTypes(this.id!);
      }
    }
    this.state.enable = true;
  }
}

const employeeDialogModel = new EmployeeDialogModel();
export default employeeDialogModel;
